import Auth from './Auth';
import api from './api';
import events from './events';

let auth = new Auth();

export {
    api,
    events,
    auth
};
